export interface ToggleSnapshot {
  compareModels: boolean;
  compareLanguages: boolean;
  showIds: boolean;
  showCosts: boolean;
  expanded: boolean;
}

export type ToggleKey = keyof ToggleSnapshot;

export interface ToggleState {
  snapshot(): ToggleSnapshot;
  toggle(key: ToggleKey): void;
  subscribe(fn: (s: ToggleSnapshot) => void): () => void;
}

export function createToggleState(): ToggleState {
  const state: ToggleSnapshot = {
    compareModels: false,
    compareLanguages: false,
    showIds: false,
    showCosts: false,
    expanded: false
  };
  const listeners = new Set<(s: ToggleSnapshot) => void>();
  return {
    snapshot: () => ({ ...state }),
    toggle(key) {
      state[key] = !state[key];
      const snap = { ...state };
      listeners.forEach(fn => fn(snap));
    },
    subscribe(fn) {
      listeners.add(fn);
      return () => {
        listeners.delete(fn);
      };
    }
  };
}
